import React from 'react'
import classnames from 'classnames/bind'

import { Typography } from '@caudena/core/ui-kit'
import { ReactComponent as LogoutIcon } from '../../assets/logout.svg'

import styles from './index.scss'
import { useInternationalizationCore } from '../../internationalization'

const cx = classnames.bind(styles)

interface LogoutButtonProps {
  logout: () => void
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ logout }) => {
  const { t } = useInternationalizationCore()

  return (
    <div className={cx('LogoutButton')} onClick={logout}>
      <div className={cx('LogoutButtonInner')}>
        <Typography className={cx('LogoutText')} variant="body2" color="grey5">
          {t('logout')}
        </Typography>
        <LogoutIcon className={cx('LogoutIcon')} />
      </div>
    </div>
  )
}

export default LogoutButton
